var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSustainable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23 14",
    style: {
      enableBackground: "new 0 0 23 14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#231F20;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.5,2C9.28,2,7.61,3.5,7.28,5.38c-0.05,0.3-0.24,0.56-0.5,0.71C6.52,6.23,6.21,6.24,5.94,6.11 C5.72,6.01,5.59,6,5.18,6C3.3,6,1.92,7.44,1.92,9c0,1.56,1.38,3,3.26,3h12.65c1.88,0,3.26-1.44,3.26-3c0-1.56-1.38-3-3.26-3 c-0.42,0-0.55,0.01-0.76,0.11c-0.27,0.13-0.58,0.12-0.84-0.02c-0.26-0.14-0.45-0.4-0.5-0.71C15.39,3.5,13.72,2,11.5,2z M5.66,4.01 C6.52,1.63,8.81,0,11.5,0c2.69,0,4.98,1.63,5.84,4.01C17.5,4,17.65,4,17.79,4c0.01,0,0.02,0,0.03,0C20.59,4,23,6.16,23,9 c0,2.84-2.41,5-5.17,5H5.18C2.41,14,0,11.84,0,9c0-2.84,2.41-5,5.18-5C5.19,4,5.2,4,5.21,4C5.35,4,5.5,4,5.66,4.01z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainable);
export default __webpack_public_path__ + "static/media/sustainable.ec571d8e37f383a73fd1a6eeb9182a91.svg";
export { ForwardRef as ReactComponent };